import React, { useContext } from 'react'
import { createPortal } from 'react-dom'

import { selectShowDocumentSummary } from '../../store/processDocument/documentSummary'
import { useAppSelector } from '../../store/hooks'

import { useZocksQuota } from '../../components/ScopedBlock/hooks'

import { DELTA_TRIAL_FEATURES } from '../Plan/DeltaTrial/DeltaTrialFeatures'
import { HeaderContext } from '../LayoutWithLeftSidebar/HeaderContext'
import { Upsell } from '../Plan/DeltaTrial/Upsell/Upsell'

import { DocumentSummaryInitialization } from './Initialization/DocumentSummaryInitialization'
import { DocumentSummaryFileUpload } from './DocumentSummary/DocumentSummaryFileUpload'
import { DocumentSummaryHeader } from './DocumentSummary/DocumentSummaryHeader'
import { DocumentSummary } from './DocumentSummary/DocumentSummary'

export const DocumentSummaryPage = () => {
  const { isFetching: quotasFetching, hasQuota, quotaSuccess } = useZocksQuota()
  const { portalRef } = useContext(HeaderContext)

  if (!quotaSuccess && quotasFetching) {
    return null
  }

  const documentSummaryEnabled = hasQuota('ai.documentSummaryAgent.value')

  return (
    <>
      {portalRef && portalRef.current ? createPortal(<DocumentSummaryHeader />, portalRef.current) : null}
      {!documentSummaryEnabled ? (
        <Upsell feature={DELTA_TRIAL_FEATURES['processDocument']} />
      ) : (
        <div className='full-size-content'>
          <DocumentSummaryInitialization />
          <DocumentSummaryContent />
        </div>
      )}
    </>
  )
}

const DocumentSummaryContent = () => {
  const showDocumentSummary = useAppSelector(selectShowDocumentSummary)

  return <div className='h-100 w-100'>{showDocumentSummary ? <DocumentSummary /> : <DocumentSummaryFileUpload />}</div>
}
